<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <!-- <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link
                to="/employee/employee-list"
                class="btn btn-icon btn-sm active bg-primary text-white me-1"
                ><i class="ti ti-list-tree"></i
              ></router-link>
              <router-link
                to="/employee/employee-grid"
                class="btn btn-icon btn-sm"
                ><i class="ti ti-layout-grid"></i
              ></router-link>
            </div>
          </div> -->
          <!-- … top toolbar … -->
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
                v-can="'Employee.Edit'"
              >
                <i class="ti ti-file-import me-1"></i>Import
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    data-bs-toggle="modal"
                    data-bs-target="#employee_csv_import_modal"
                  >
                    <i class="ti ti-users me-1"></i>Import Employees
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    data-bs-toggle="modal"
                    data-bs-target="#employee_email_import_modal"
                  >
                    <i class="ti ti-mail me-1"></i>Update Emails
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportPDF"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportCSV"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_employee"
              class="btn btn-primary d-flex align-items-center"
              @click="openAddModal"
              v-can="'Employee.Create'"
              ><i class="ti ti-circle-plus me-2"></i>Add New Employee</a
            >
          </div>
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              class=""
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- STATS ROW -->
      <div class="row dq-stat-grid">
        <!-- Total Employee -->
        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between dq-stat-card"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <div>
                  <span class="avatar avatar-lg bg-dark rounded-circle"
                    ><i class="ti ti-users"></i
                  ></span>
                </div>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">
                    Total Employee
                  </p>
                  <h4>{{ stats.total }}</h4>
                </div>
              </div>
              <div>
                <span class="badge badge-soft-purple badge-sm fw-normal">
                  <i class="ti ti-arrow-wave-right-down"></i>
                  {{ stats.deltaTotal }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Active -->
        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between dq-stat-card"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <div>
                  <span class="avatar avatar-lg bg-success rounded-circle"
                    ><i class="ti ti-user-share"></i
                  ></span>
                </div>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">Active</p>
                  <h4>{{ stats.active }}</h4>
                </div>
              </div>
              <div>
                <span class="badge badge-soft-primary badge-sm fw-normal">
                  <i class="ti ti-arrow-wave-right-down"></i>
                  {{ stats.deltaActive }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Inactive -->
        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between dq-stat-card"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <div>
                  <span class="avatar avatar-lg bg-danger rounded-circle"
                    ><i class="ti ti-user-pause"></i
                  ></span>
                </div>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">InActive</p>
                  <h4>{{ stats.inactive }}</h4>
                </div>
              </div>
              <div>
                <span class="badge badge-soft-dark badge-sm fw-normal">
                  <i class="ti ti-arrow-wave-right-down"></i>
                  {{ stats.deltaInactive }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- New Joiners -->
        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between dq-stat-card"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <div>
                  <span class="avatar avatar-lg bg-info rounded-circle"
                    ><i class="ti ti-user-plus"></i
                  ></span>
                </div>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">New Joiners</p>
                  <h4>{{ stats.newJoiners }}</h4>
                </div>
              </div>
              <div>
                <span class="badge badge-soft-secondary badge-sm fw-normal">
                  <i class="ti ti-arrow-wave-right-down"></i>
                  {{ stats.deltaNewJoiners }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div
          class="card-header d-flex align-items-end justify-content-between flex-wrap gap-3"
        >
          <div class="me-auto">
            <h5 class="mb-1">Employee List</h5>
            <div class="text-muted fs-13">{{ listSummary }}</div>
          </div>
          <div class="dq-employee-search">
            <label class="form-label text-muted small mb-1" for="employee-list-search">
              Search
            </label>
            <div class="input-icon-start position-relative">
              <span class="input-icon-addon">
                <i class="ti ti-search"></i>
              </span>
              <input
                id="employee-list-search"
                v-model.trim="listSearch"
                type="search"
                class="form-control"
                placeholder="Name, Emp ID, email, phone…"
                autocomplete="off"
              />
              <button
                v-if="listSearch"
                type="button"
                class="btn p-0 dq-employee-search-clear"
                title="Clear search"
                aria-label="Clear search"
                @click="listSearch = ''"
              >
                <i class="ti ti-x"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card-header border-top d-flex align-items-center justify-content-end flex-wrap row-gap-3 py-2">
          <!-- FILTER BAR (wire the actions) -->
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3 dq-list-toolbar"
          >
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon"
                  ><i class="ti ti-chevron-down"></i
                ></span>
              </div>
            </div>

            <!-- Designation filter -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ selectedDesignationLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setDesignation(null)"
                    >All</a
                  >
                </li>
                <li v-for="d in designations" :key="d.id">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setDesignation(d.id)"
                    >{{ d.name }}</a
                  >
                </li>
              </ul>
            </div>

            <!-- Section filter -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ selectedSectionLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSection(null)"
                    >All</a
                  >
                </li>
                <li v-for="s in sections" :key="s.id">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSection(s.id)"
                    >{{ s.name }}</a
                  >
                </li>
              </ul>
            </div>

            <!-- Status filter -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ selectedStatusLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setStatus(null)"
                    >All</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setStatus('Active')"
                    >Active</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setStatus('Inactive')"
                    >Inactive</a
                  >
                </li>
              </ul>
            </div>

            <!-- Access filter -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ selectedAccessLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setAccessFilter(null)"
                    >All access</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setAccessFilter('missing_email')"
                    >Missing email</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setAccessFilter('missing_login')"
                    >Missing login</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setAccessFilter('ready_for_invite')"
                    >Ready for invite</a
                  >
                </li>
              </ul>
            </div>

            <div class="me-3" v-can="'Employee.Edit'">
              <button
                type="button"
                class="btn btn-white d-inline-flex align-items-center"
                :disabled="!selectedEmployeeIds.length"
                @click="openBulkLoginModal(false)"
              >
                <i class="ti ti-key me-1"></i>
                Enable Portal Access
                <span v-if="selectedEmployeeIds.length" class="ms-1">({{ selectedEmployeeIds.length }})</span>
              </button>
            </div>

            <div class="me-3" v-can="'Employee.Edit'">
              <button
                type="button"
                class="btn btn-white d-inline-flex align-items-center"
                @click="openBulkLoginModal(true)"
              >
                <i class="ti ti-mail-forward me-1"></i>
                Invite All Ready
              </button>
            </div>

            <!-- Sort -->
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSort('recent')"
                    >Recent Joiners</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSort('name_asc')"
                    >Name A → Z</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSort('name_desc')"
                    >Name Z → A</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <a-table
              class="table datatable thead-light"
              :columns="columns"
              :data-source="tableData"
              row-key="id"
              :row-selection="rowSelection"
              :customRow="customRow"
              :pagination="tablePagination"
              @change="onTableChange"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Name'">
                  <div class="d-flex align-items-center file-name-icon">
                    <a
                      href="javascript:void(0);"
                      @click.stop
                    >
                      <DqAvatar
                        :src="record.Image"
                        :name="record.Name"
                        size-class="avatar-md"
                        shape-class="rounded-circle"
                      />
                    </a>
                    <div class="ms-2">
                      <h6 class="fw-medium">
                        <a href="javascript:void(0);" @click.stop>{{
                          record.Name
                        }}</a>
                      </h6>
                      <span class="d-block mt-1">
                        {{ record.Work
                        }}<template v-if="record.Section"
                          > · {{ record.Section }}</template
                        >
                      </span>
                    </div>
                  </div>
                </template>
                <template v-if="column.key === 'Designation'">
                  {{ record.Designation }}
                </template>
                <template v-if="column.key === 'Section'">
                  {{ record.Section || "—" }}
                </template>
                <template v-if="column.key === 'Manager'">
                  {{ record.Manager || "—" }}
                </template>

                <template v-if="column.key === 'Status'">
                  <span
                    :class="[
                      'badge',
                      record.Status === 'Active'
                        ? 'badge-success'
                        : record.Status === 'Inactive'
                        ? 'badge-danger'
                        : 'd-inline-flex',
                      'align-items-center',
                      'badge-xs',
                    ]"
                  >
                    <i class="ti ti-point-filled me-1"></i>
                    {{ record.Status }}
                  </span>
                  <div class="small text-muted mt-1">
                    <span v-if="record.has_login" class="text-success">Portal login</span>
                    <span v-else-if="record.ready_for_invite" class="text-primary">Ready to invite</span>
                    <span v-else-if="record.missing_email">Missing email</span>
                    <span v-else>No login</span>
                  </div>
                  <div v-if="record.onboarding_label" class="mt-1">
                    <span class="badge badge-soft-warning badge-xs fw-normal">
                      {{ record.onboarding_label }}
                    </span>
                  </div>
                </template>
                <template v-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      @click.stop.prevent="goToDetails(record)"
                      title="View"
                      v-can="'Employee.Read'"
                    >
                      <i class="ti ti-eye"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#add_employee"
                      @click.stop.prevent="openEditModal(record)"
                      v-can="'Employee.Edit'"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <a
                      v-if="record.has_login"
                      href="javascript:void(0);"
                      class="me-2"
                      title="Resend set-password email"
                      v-can="'Employee.Edit'"
                      @click.stop.prevent="resendSetPassword(record)"
                    >
                      <i class="ti ti-mail-forward"></i>
                    </a>
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_modal"
                      v-can="'Employee.Delete'"
                      @click.stop.prevent="openDeleteModal(record)"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <!-- <EmployeeListModal
    ref="modalEmployee"
    :employee="modalEmployee"
    :employee-id="!modalEmployee ? nextEmployeeId : modalEmployee.employee_id"
    @refresh="fetchEmployeey"
  /> -->

  <EmployeeListModal
    ref="employeeModalRef"
    :employeeToDelete="toDeleteEmployee"
    :employee="modalEmployee"
    :employeeId="modalEmployee ? modalEmployee.employee_id : nextEmployeeId"
    @refresh="fetchEmployees"
  />
  <EmployeeEmailImportModal @imported="onEmailsImported" />
  <EmployeeBulkLoginModal
    :employee-ids="selectedEmployeeIds"
    :all-ready="bulkLoginAllReady"
    @invited="onLoginsProvisioned"
  />
  <CsvImportModal
    modal-id="employee_csv_import_modal"
    title="Import Employees from CSV"
    description="Create employees in bulk. Blank emails get a placeholder (no login). Import departments, sections (optional), and designations first if you include those columns."
    template-hint="Required: PayrollNumber, First Name. Optional: Email, Phone, Department, Section, Designation, Joining Date, Gender, Status, National ID, KRA PIN, NSSF Number, SHIF/SHA Number."
    template-filename="employee-import-template.csv"
    :columns="employeeImportColumns"
    :download-template-fn="downloadEmployeeTemplate"
    :preview-fn="previewEmployeeImport"
    :apply-fn="applyEmployeeImport"
    @imported="onEmailsImported"
  />
</template>
<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, onMounted, computed, nextTick, watch } from "vue";
import { Modal } from "bootstrap";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import { useDesignationStore } from "@/stores/designationStore";
import { useSectionStore } from "@/stores/sectionStore";
import { useEmployeeStore } from "@/stores/employeeStore";
import { storeToRefs } from "pinia";
import EmployeeListModal from "@/components/modal/employee-list-modal.vue";
import EmployeeEmailImportModal from "@/components/modal/employee-email-import-modal.vue";
import EmployeeBulkLoginModal from "@/components/modal/employee-bulk-login-modal.vue";
import CsvImportModal from "@/components/modal/csv-import-modal.vue";
import employeeService from "@/services/hrm/employeeService";
import { useRouter } from "vue-router";
import DqAvatar from "@/components/shared/DqAvatar.vue";
import { toast } from "@/utils/toast";
import {
  isMissingEmployeeEmail,
  hasEmployeeLogin,
  isReadyForLoginInvite,
} from "@/utils/employeeEmail";

const employeeImportColumns = [
  { key: "line", title: "Line" },
  { key: "payroll_number", title: "Payroll No." },
  { key: "employee_name", title: "Name" },
  { key: "email", title: "Email" },
  { key: "department", title: "Department" },
  { key: "section", title: "Section" },
  { key: "designation", title: "Designation" },
];

function downloadEmployeeTemplate() {
  return employeeService.downloadEmployeeImportTemplate();
}
function previewEmployeeImport(file, mode) {
  return employeeService.previewEmployeeImport(file, mode);
}
function applyEmployeeImport(file, mode) {
  return employeeService.applyEmployeeImport(file, mode);
}

// --- STATIC DATA ---
const columns = [
  { sorter: false },
  {
    title: "Emp ID",
    dataIndex: "EmpID",
    sorter: {
      compare: (a, b) => {
        a = a.EmpID.toLowerCase();
        b = b.EmpID.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
    sorter: {
      compare: (a, b) => {
        a = a.Name.toLowerCase();
        b = b.Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Email",
    dataIndex: "Email",
    sorter: {
      compare: (a, b) => {
        a = a.Email.toLowerCase();
        b = b.Email.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Phone",
    dataIndex: "Phone",
    sorter: {
      compare: (a, b) => {
        a = a.Phone.toLowerCase();
        b = b.Phone.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Section",
    dataIndex: "Section",
    key: "Section",
    sorter: {
      compare: (a, b) => {
        a = (a.Section || "").toLowerCase();
        b = (b.Section || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Designation",
    dataIndex: "Designation",
    key: "Designation",
    sorter: {
      compare: (a, b) => {
        a = a.Designation.toLowerCase();
        b = b.Designation.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Manager",
    dataIndex: "Manager",
    key: "Manager",
    sorter: {
      compare: (a, b) => {
        a = (a.Manager || "").toLowerCase();
        b = (b.Manager || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Joining Date",
    dataIndex: "JoiningDate",
    key: "JoiningDate",
    sorter: {
      compare: (a, b) => {
        a = a.JoiningDate.toLowerCase();
        b = b.JoiningDate.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  { title: "", key: "action", sorter: false },
];

const router = useRouter();
const designationStore = useDesignationStore();
const { designations } = storeToRefs(designationStore);
const sectionStore = useSectionStore();
const { sections } = storeToRefs(sectionStore);
const employeeStore = useEmployeeStore();
const { employees } = storeToRefs(employeeStore);

const filter = ref({
  designationId: null,
  sectionId: null,
  status: null,
  access: null,
  dateFrom: null,
  dateTo: null,
  sort: "recent",
});
const listSearch = ref("");
const tablePagination = ref({
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "50", "100"],
  showTotal: (total, range) => `${range[0]}–${range[1]} of ${total}`,
});

const selectedEmployeeIds = ref([]);
const bulkLoginAllReady = ref(false);

async function openBulkLoginModal(allReady = false) {
  bulkLoginAllReady.value = !!allReady;
  await nextTick();
  const modalEl = document.getElementById("employee_bulk_login_modal");
  if (!modalEl) {
    toast("Portal access dialog failed to load. Please refresh the page.", "error");
    return;
  }
  Modal.getOrCreateInstance(modalEl).show();
}

// Table data now maps filteredEmployees
const tableData = computed(() =>
  filteredEmployees.value.map((e) => ({
    _raw: e,
    id: e.id,
    key: e.id,
    EmpID: e.employee_id,
    Name: [e.first_name, e.middle_name, e.last_name].filter(Boolean).join(" "),
    Work: e.department?.name || "",
    Section: e.section?.name || "",
    Email: e.email,
    Phone: e.phone,
    Designation: e.designation?.name || "",
    Manager:
      e.manager_name ||
      [e.manager?.first_name, e.manager?.last_name].filter(Boolean).join(" ") ||
      "",
    JoiningDate: e.company_doj
      ? new Date(e.company_doj).toLocaleDateString()
      : "",
    Status: e.status,
    Image: e?.avatar_url || "",
    designation_id: e.designation_id,
    section_id: e.section_id,
    department_id: e.department_id,
    username: e.username,
    first_name: e.first_name,
    last_name: e.last_name,
    email: e.email,
    phone: e.phone,
    company_doj: e.company_doj,
    image_url: e.avatar_url,
    employee_id: e.employee_id,
    permissions: e?.user?.permissions,
    about: e.about,
    company: e.company,
    has_login: hasEmployeeLogin(e),
    missing_email: isMissingEmployeeEmail(e.email),
    ready_for_invite: isReadyForLoginInvite(e),
    onboarding_label:
      e.status === "Active" ? e.onboarding_summary?.list_label || "" : "",
  })),
);

const rowSelection = computed(() => ({
  selectedRowKeys: selectedEmployeeIds.value,
  onChange: (keys) => {
    selectedEmployeeIds.value = (keys || []).map((k) => Number(k));
  },
}));

// --- STATE FOR TITLE/BREADCRUMB ---
const title = ref("All Employees");
const text = ref("Employees");
const text1 = ref("All Employees");

function booking_range(start, end) {
  return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
}

async function fetchEmployees() {
  await employeeStore.ensureEmployees({}, { force: false });
}

async function onEmailsImported() {
  employeeStore.invalidateEmployeeCaches();
  await employeeStore.ensureEmployees({}, { force: true });
}

async function onLoginsProvisioned() {
  selectedEmployeeIds.value = [];
  employeeStore.invalidateEmployeeCaches();
  await employeeStore.ensureEmployees({}, { force: true });
}

const selectedDesignationLabel = computed(() => {
  if (!filter.value.designationId) return "Designation";
  const d = designations.value.find((x) => x.id === filter.value.designationId);
  return d ? d.name : "Designation";
});

const selectedSectionLabel = computed(() => {
  if (!filter.value.sectionId) return "Section";
  const s = sections.value.find((x) => x.id === filter.value.sectionId);
  return s ? s.name : "Section";
});

const selectedStatusLabel = computed(() =>
  filter.value.status ? `Status: ${filter.value.status}` : "Select Status",
);

const selectedAccessLabel = computed(() => {
  switch (filter.value.access) {
    case "missing_email":
      return "Missing email";
    case "missing_login":
      return "Missing login";
    case "ready_for_invite":
      return "Ready for invite";
    default:
      return "All access";
  }
});

const sortLabel = computed(() => {
  switch (filter.value.sort) {
    case "name_asc":
      return "Name A → Z";
    case "name_desc":
      return "Name Z → A";
    default:
      return "Recent Joiners";
  }
});

const dateRangeInput = ref(null);
const dateRangePicked = ref(false);

onMounted(fetchEmployees);

onMounted(() => {
  if (!designations.value.length) designationStore.ensureDesignations();
  if (!sections.value.length) sectionStore.ensureSections();

  if (dateRangeInput.value) {
    new DateRangePicker(
      dateRangeInput.value,
      {
        autoUpdateInput: false,
        locale: { cancelLabel: "Clear" },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      (start, end) => {
        filter.value.dateFrom = start.startOf("day").toDate();
        filter.value.dateTo = end.endOf("day").toDate();
        dateRangePicked.value = true;
        if (dateRangeInput.value) {
          dateRangeInput.value.value = booking_range(start, end);
        }
      },
    );
  }
});

// --- HEADER COLLAPSE ---
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

// Auto-generate next Employee ID for add modal
const nextEmployeeId = computed(() => {
  if (!employees.value.length) return "EMP-0001";
  const ids = employees.value
    .map((e) => e.employee_id)
    .filter(Boolean)
    .map((id) => parseInt(id.replace(/[^\d]/g, ""), 10));
  const nextNum = Math.max(...ids, 0) + 1;
  return `EMP-${nextNum.toString().padStart(4, "0")}`;
});

const modalEmployee = ref(null);
const employeeModalRef = ref(null);
const toDeleteEmployee = ref(null);

function openAddModal() {
  modalEmployee.value = null;
}
function openEditModal(row) {
  // row._raw is the real model we’ll inject below
  modalEmployee.value = row._raw;
}

function openDeleteModal(row) {
  toDeleteEmployee.value = row._raw;
}

async function resendSetPassword(row) {
  const employee = row?._raw || row;
  if (!employee?.id) return;
  try {
    const { data } = await employeeService.resendSetPasswordEmail(employee.id);
    toast(data?.message || "Set-password email sent.", "success");
  } catch (e) {
    toast(
      e?.response?.data?.message || "Failed to send set-password email.",
      "error",
    );
  }
}

function setDesignation(id) {
  filter.value.designationId = id;
}
function setSection(id) {
  filter.value.sectionId = id;
}
function setStatus(s) {
  filter.value.status = s;
}
function setAccessFilter(value) {
  filter.value.access = value;
}
function setSort(s) {
  filter.value.sort = s;
}

function onTableChange(pag) {
  tablePagination.value = {
    ...tablePagination.value,
    current: pag?.current || 1,
    pageSize: pag?.pageSize || tablePagination.value.pageSize,
  };
}

watch([listSearch, filter], () => {
  tablePagination.value = {
    ...tablePagination.value,
    current: 1,
  };
}, { deep: true });

const listSummary = computed(() => {
  const shown = filteredEmployees.value.length;
  const total = (employees.value || []).length;
  const q = String(listSearch.value || "").trim();
  if (q) {
    return shown === 1
      ? `1 employee matching “${q}”`
      : `${shown} employees matching “${q}”`;
  }
  if (shown !== total) {
    return `Showing ${shown} of ${total} employees`;
  }
  return total === 1 ? "1 employee" : `${total} employees`;
});

const filteredEmployees = computed(() => {
  let rows = [...(employees.value || [])];

  const q = String(listSearch.value || "")
    .trim()
    .toLowerCase();
  if (q) {
    rows = rows.filter((e) => {
      const haystack = [
        e.first_name,
        e.middle_name,
        e.last_name,
        e.employee_id,
        e.email,
        e.phone,
        e.username,
        e.department?.name,
        e.section?.name,
        e.designation?.name,
        e.manager_name,
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      return haystack.includes(q);
    });
  }

  // Designation
  if (filter.value.designationId) {
    rows = rows.filter(
      (e) => Number(e.designation_id) === Number(filter.value.designationId),
    );
  }

  // Section
  if (filter.value.sectionId) {
    rows = rows.filter(
      (e) => Number(e.section_id) === Number(filter.value.sectionId),
    );
  }

  // Status
  if (filter.value.status) {
    rows = rows.filter(
      (e) =>
        (e.status || "").toLowerCase() === filter.value.status.toLowerCase(),
    );
  }

  if (filter.value.access === "missing_email") {
    rows = rows.filter((e) => isMissingEmployeeEmail(e.email));
  } else if (filter.value.access === "missing_login") {
    rows = rows.filter((e) => !hasEmployeeLogin(e));
  } else if (filter.value.access === "ready_for_invite") {
    rows = rows.filter((e) => isReadyForLoginInvite(e));
  }

  // Date range (joining date)
  if (dateRangePicked.value && filter.value.dateFrom && filter.value.dateTo) {
    const from = filter.value.dateFrom.getTime();
    const to = filter.value.dateTo.getTime();
    rows = rows.filter((e) => {
      const ts = e.company_doj ? new Date(e.company_doj).getTime() : null;
      return ts ? ts >= from && ts <= to : true;
    });
  }

  // Sort
  switch (filter.value.sort) {
    case "name_asc":
      rows.sort((a, b) =>
        (a.first_name + " " + (a.last_name || "")).localeCompare(
          b.first_name + " " + (b.last_name || ""),
        ),
      );
      break;
    case "name_desc":
      rows.sort((a, b) =>
        (b.first_name + " " + (b.last_name || "")).localeCompare(
          a.first_name + " " + (a.last_name || ""),
        ),
      );
      break;
    default: // 'recent' by joining date desc
      rows.sort(
        (a, b) => new Date(b.company_doj || 0) - new Date(a.company_doj || 0),
      );
  }

  return rows;
});

// Dynamic stats (follow current filter)
const stats = computed(() => {
  const rows = filteredEmployees.value;
  const total = rows.length;
  const active = rows.filter(
    (r) => (r.status || "").toLowerCase() === "active",
  ).length;
  const inactive = rows.filter(
    (r) => (r.status || "").toLowerCase() === "inactive",
  ).length;

  // New joiners: within current date range; fallback to last 30 days if no range
  const now = new Date();
  const from =
    filter.value.dateFrom || new Date(now.getTime() - 29 * 24 * 3600 * 1000);
  const to = filter.value.dateTo || now;
  const fromTs = from.getTime(),
    toTs = to.getTime();
  const newJoiners = rows.filter((r) => {
    const ts = r.company_doj ? new Date(r.company_doj).getTime() : 0;
    return ts >= fromTs && ts <= toTs;
  }).length;

  // Placeholder deltas (you can replace with server-provided growth if available)
  return {
    total,
    active,
    inactive,
    newJoiners,
    deltaTotal: "+0%",
    deltaActive: "+0%",
    deltaInactive: "+0%",
    deltaNewJoiners: "+0%",
  };
});

// EXPORTS (use current filtered view)
function exportCSV() {
  employeeStore.downloadReport("xlsx", buildExportParams());
}

function exportPDF() {
  employeeStore.downloadReport("pdf", buildExportParams());
}

function formatDateParam(value) {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
}

function buildExportParams() {
  return {
    designation_id: filter.value.designationId || "",
    status: filter.value.status || "",
    date_from: formatDateParam(filter.value.dateFrom),
    date_to: formatDateParam(filter.value.dateTo),
    sort:
      filter.value.sort === "name_asc"
        ? "asc"
        : filter.value.sort === "name_desc"
          ? "desc"
          : "recent",
  };
}

const handleRowClick = (record) => {
  const id = record._raw.id;
  if (id) {
    // Navigate to employee details page with the employee ID as a query parameter
    router.push({ path: "/employee/employee-details", query: { id } });
  }
};

function goToDetails(record) {
  const id = record._raw?.id || record.id;
  if (id) router.push({ path: "/employee/employee-details", query: { id } });
}

const customRow = (record) => ({
  onClick: () => goToDetails(record),
  onKeydown: (e) => {
    if (e.key === "Enter") goToDetails(record);
  }, // a11y
  style: { cursor: "pointer" },
  role: "button",
  tabindex: 0,
});
</script>
<style scoped>
.table .ant-table-tbody > tr:hover {
  background: #fafafa;
}
.dq-employee-search {
  min-width: 260px;
  max-width: 360px;
  flex: 1 1 260px;
}
.dq-employee-search .form-control {
  padding-left: 2.35rem;
  padding-right: 2.1rem;
  min-height: 40px;
}
.dq-employee-search-clear {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  line-height: 1;
  color: rgba(17, 24, 39, 0.45);
  z-index: 2;
}
.dq-employee-search-clear:hover {
  color: rgba(17, 24, 39, 0.85);
}
</style>


